import {Button} from '@mui/material';
import {loadUser} from '@zs21/drv-bund-common-ilias-utils';
import {useEffect, useState} from "react";
import CustomModal from '../CustomModal';
import React from 'react';

const internalCtaUrl = 'https://remedy-portal.prod.bund.drv/dwp/rest/share/OJSXG33VOJRWKVDZOBST2U2SIQTHIZLOMFXHISLEHUYDAMBQGAYDAMBQGAYDAMBQGETHEZLTN52XEY3FJFSD2U2SI5AUCNKWGBAUCQRWGZAVESKRGRJUOUSIKJCTIWKOLBBEKJTDN5XHIZLYORKHS4DFHVBUCVCBJRHUOX2IJ5GUKJTQOJXXM2LEMVZFG33VOJRWKTTBNVST243SNU======';
const externalCtaUrl = 'https://lernwelt.drv-bund.de/goto.php?target=crs_60240';

function ReportProblemModal() {
    const [modalOpen, setModalOpen] = useState(false);
    const [hasInternalAccess, setHasInternalAccess] = useState(false);

    useEffect(() => {
        loadUser().then(user => {
            setHasInternalAccess(user.loggedInViaSSO);
        });
    }, []);

    window.openReportProblemModal = () => {
        setModalOpen(true);
    };

    const hideModal = () => {
        setModalOpen(false);
    }

    const getContent = () => {
        if (!hasInternalAccess) {
            return (
                <>
                    <p style={{marginTop: 0}}>
                        Bitte informieren Sie sich in der nachfolgenden Anleitung, ob Sie Ihr Problem selbstständig lösen können.
                    </p>
                    <p>
                        Sollte Ihr Problem weiterhin bestehen, können Sie sich auch an unseren Postkorb <a
                        href="mailto:mobiles-lernen@drv-bund.de">mobiles-lernen@drv-bund.de</a> wenden.
                    </p>
                    <div style={{textAlign: 'right'}}>
                        <Button variant={'contained'} href={externalCtaUrl} onClick={hideModal} target="_blank">Zur Anleitung</Button>
                    </div>
                </>
            );
        }

        return (
            <>
                <p style={{marginTop: 0}}>
                    Um Ihre Meldung möglichst schnell bearbeiten zu können, bitten wir das Formular im Remedy Portal
                    entsprechend auszufüllen.
                </p>
                <p>
                    Falls Sie Ihr Anliegen dort nicht wiederfinden, können Sie dieses auch per
                    E-Mail (<a href="mailto:service-desk@drv-bund.de">service-desk@drv-bund.de</a>) oder telefonisch (<a href="tel:+493086531111">030 - 865 31 111</a>) melden.
                </p>
                <div style={{textAlign: 'right'}}>
                    <Button variant={'contained'} href={internalCtaUrl} onClick={hideModal} target="_blank">Zum Remedy Formular</Button>
                </div>
            </>
        );
    }

    return (
        <>
            <CustomModal title={'Hilfe bei technischen Problemen'} open={modalOpen} onClose={hideModal}>
                {getContent()}
            </CustomModal>
        </>
    );
}

export default ReportProblemModal;
